const ENVIRONMENTS = {
  dev: 'https://dev.api.smart.juganu.com',
  staging: 'https://staging.api.smart.juganu.com',
  prod: 'https://prod.api.smart.juganu.com'
};

const config = {
  apiPathUrl: 'api/v1/nms',
  graphqlPathUrl: 'api/v1/graphql',
  get apiBaseUrl() {
    const env = localStorage.getItem('environment') || 'dev';
    return ENVIRONMENTS[env];
  },
  get apiUrl() {
    return `${this.apiBaseUrl}/${this.apiPathUrl}`;
  },
  get graphqlUrl() {
    return `${this.apiBaseUrl}/${this.graphqlPathUrl}`;
  },
  setEnvironment(env) {
    if (!ENVIRONMENTS[env]) {
      throw new Error(`Invalid environment: ${env}`);
    }
    localStorage.setItem('environment', env);
  },
  getEnvironment() {
    return localStorage.getItem('environment') || 'dev';
  }
};

export default config;
